import{gql as e}from"@apollo/client";const m=e`
  mutation updateUserAsAdmin(
    $communityName: String
    $email: String
    $firstName: String
    $lastName: String
    $phoneNumber: String
    $userId: Int!
    $phoneNumberCountryCode: ECountries
  ) {
    user {
      updateUserAsAdmin(
        communityName: $communityName
        email: $email
        firstname: $firstName
        lastname: $lastName
        phoneNumber: $phoneNumber
        phoneNumberCountryCode: $phoneNumberCountryCode
        userId: $userId
      )
    }
  }
`;export{m as UPDATE_USER_AS_ADMIN_MUTATION};
//# sourceMappingURL=useUpdateUserAsAdmin.graphql.js.map
